import { VerifiedBadge } from "@/components/VerifiedBadge";
import { KEY_MOMENTS } from "@/pages/Landing";
import { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export function MatchmakingStatusBar({ profile, user, active, onVerify, onVerifyFree, onPause, onResume, onReactivate }) {
  return (
    <div className="bg-white border border-border rounded-sm p-6">
      {!profile.verified ? (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-sm bg-amber-50 text-amber-600 grid place-items-center"><ShieldAlert className="w-5 h-5" /></span>
            <div>
              <div className="font-display text-lg font-semibold">Get verified to receive offers</div>
              <div className="text-sm text-muted-foreground">
                {user?.promo_free_eligible
                  ? "You're one of our first 100 tenants — verification is FREE for you!"
                  : "One-time $24.99 — runs background, credit, income & ID checks."}
              </div>
            </div>
          </div>
          {user?.promo_free_eligible ? (
            <Button data-testid="verify-free-btn" className="bg-emerald-600 hover:bg-emerald-700" onClick={onVerifyFree}>Verify FREE 🎉</Button>
          ) : (
            <Button data-testid="verify-btn" onClick={onVerify}>Verify for $24.99</Button>
          )}
        </div>
      ) : (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={profile.photo_url ? fileUrl(profile.photo_url) : KEY_MOMENTS[0].url} alt="verified renter" className="w-11 h-11 rounded-full object-cover border-2 border-emerald-200 hidden sm:block" />
            <span className={`w-3 h-3 rounded-full ${active ? "bg-emerald-500 animate-pulse" : "bg-slate-300"}`} />
            <div>
              <div className="font-display text-lg font-semibold flex items-center gap-2" data-testid="matchmaking-status">
                {active ? "Matchmaking Active" : "Matchmaking Paused"}
                <VerifiedBadge date={profile.verified_at} />
              </div>
              <div className="text-sm text-muted-foreground">
                {active ? "Landlords can find you and send offers." : "Hidden from browse. Reactivate ($10) to go live with a fresh credit check."}
                {profile.credit_score && <> · Credit score {profile.credit_score}</>}
              </div>
            </div>
          </div>
          {active ? (
            <Button variant="outline" data-testid="pause-btn" onClick={onPause}>Pause matchmaking</Button>
          ) : (
            <div className="flex items-center gap-2">
              <Button data-testid="resume-btn" onClick={onResume}>Resume matchmaking</Button>
              <Button variant="ghost" size="sm" data-testid="reactivate-btn" onClick={onReactivate}>Fresh check · $10</Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
